module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div id="widget_header_region" class="vertical_widget_header"></div>\n<div id="interactive_region"></div>\n<div aria-label="Vertical carousel of images with text descriptions and social media handles." class="wrap" id="vertical_widget" role="region">\n	<div class="controls">\n		<div aria-label="' +
((__t = ( I18n.t('common.controls.previous') )) == null ? '' : __t) +
'" class="btn prev" role="button" tabindex="0"></div>\n		<div aria-label="' +
((__t = ( I18n.t('common.controls.next') )) == null ? '' : __t) +
'" class="btn next" role="button" tabindex="0"></div>\n	</div>\n	<div id="frame" class="vertical_frame">\n	</div>\n</div>\n';

}
return __p
}